import React from "react";
import "../assets/css/home.css";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import Logo from "../assets/img/src/timebooth_typo--m.png";
import DirectionsRunIcon from "@material-ui/icons/DirectionsRun";
import FooterBox from "../components/footer/FooterBox";

const Home = () => {
  const dispatch = useDispatch();

  return (
    <>
      <div className="home-container center">
        <div className="home-container--inner center-box">
          <div className="spacer-box--l" />
          <img className="logo-title--home" src={Logo} alt="ロゴ画像" />
          <div className="sub-title">- 作家が語る芸術品販売プラットフォーム -</div>
          <div className="spacer-box--l" />
          <div className="home-text yu-gothic">
            <div className="home-text--size">気になる作品</div>
            <div className="home-text--size">好きな作品</div>
            <div className="home-text--size">もっと知りたいその作品</div>
            <div className="spacer-box--s" />
            <div className="home-text--size">作家に会えばもっと好きになる</div>
            <div className="home-text--size">あなたの「欲しい」を最高潮へ</div>
          </div>
          <div className="spacer-box--l" />
          <div className="spacer-box--s" />
          <div className="start-btn" onClick={() => dispatch(push("/boothlist"))}>
            <div className="flex-row">
              <div className="start-btn-style--icon">
                <DirectionsRunIcon fontSize="small" />
              </div>
              <div className="start-btn-style--text yu-gothic">Enter</div>
            </div>
          </div>
        </div>
      </div>
      <FooterBox />
    </>
  );
};

export default Home;
